module.exports = __webpack_public_path__ + "static/media/house-icon.f0b90cb7.svg";